import { combineReducers } from 'redux';

import article from './article';
import media from './media';
import morenews from './morenews';
import skysso from './skysso';
import userService from './userService';
import layout from './layout';
import omniture from './omniture';
import pageTranstition from './pageTranstition';
import display from './display';
import queryParams from './queryParams';
import betlink from './betlink';
import atrVideo from './atrVideo';
import metaData from './metaData';
import canary from './canary';
import cookies from './cookies';
import window from './window';
import betslip from './betslip';
import menu from './menu';
import tamGpt from './tamGpt';
import splashpage from './splashpage';

export default combineReducers({
  article,
  media,
  morenews,
  auth: skysso,
  userService,
  pageTranstition,
  layout,
  omniture,
  display,
  queryParams,
  betlink, // Only relevant for feature "integrated-betslip"
  atrVideo,
  metaData,
  canary,
  cookies,
  window,
  betslip,
  tamGpt,
  menu,
  splashpage
});



// WEBPACK FOOTER //
// ./modules/Common/reducers/reducer.js